/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElectricalSettingsComponent } from './electrical-settings.component';
import { DxButtonModule, DxSelectBoxModule, DxTooltipModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/electrical-settings-dialog', component: ElectricalSettingsComponent }];

@NgModule({
  declarations: [ElectricalSettingsComponent],
  imports: [
    CommonModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxTooltipModule,
    FormsModule,
    SysqueFrameModule,
    AlertModule,
    RouterModule.forChild(routes)
  ],
  exports: [ElectricalSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ElectricalSettingsModule {}
